import { z } from "@/zod";
import { ulid, dateTime, nonNegativeDecimalStringSchema } from "./commonFields";

export const readContractorsPlannedHoursApproval = z
  .object({
    id: ulid,
    contractor_user_ref_number: z.number(),
    contractor_full_name: z.string(),
    contractor_personal_id_number: z.string(),
    contractor_phone_number: z.string().optional(),
    contractor_email: z.string().optional(),
    period: z.string(),
    approved_at: dateTime,
    last_planned_hours_value: nonNegativeDecimalStringSchema,
  })
  .readonly();
